/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Watch_HeadingInputs */

const th_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังรับชม`)
};

const en_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watching`)
};

const ja_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`視聴中`)
};

const zh_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观看`)
};

const es_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viendo`)
};

const pt_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistindo`)
};

const id_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tonton`)
};

const fr_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En train de regarder`)
};

const tl_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manood`)
};

const vi_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem`)
};

const ko_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시청`)
};

const de_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuschauen`)
};

const ru_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотр`)
};

const tr_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzle`)
};

const it_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda`)
};

const pl_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oglądaj`)
};

const uk_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегляд`)
};

const hi_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देखें`)
};

const ar_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاهدة`)
};

const ms_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tonton`)
};

const bn_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দেখুন`)
};

const zh_tw2_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`觀看`)
};

const zh_hk2_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`觀看`)
};

const ur_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دیکھیں`)
};

const fa_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تماشا`)
};

const sw_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tazama`)
};

const nl_video_watch_heading = /** @type {(inputs: Video_Watch_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kijken`)
};

/**
* | output |
* | --- |
* | "Watching" |
*
* @param {Video_Watch_HeadingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_watch_heading = /** @type {((inputs?: Video_Watch_HeadingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Watch_HeadingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_watch_heading(inputs)
	if (locale === "ja") return ja_video_watch_heading(inputs)
	if (locale === "zh") return zh_video_watch_heading(inputs)
	if (locale === "es") return es_video_watch_heading(inputs)
	if (locale === "pt") return pt_video_watch_heading(inputs)
	if (locale === "id") return id_video_watch_heading(inputs)
	if (locale === "fr") return fr_video_watch_heading(inputs)
	if (locale === "tl") return tl_video_watch_heading(inputs)
	if (locale === "vi") return vi_video_watch_heading(inputs)
	if (locale === "ko") return ko_video_watch_heading(inputs)
	if (locale === "de") return de_video_watch_heading(inputs)
	if (locale === "ru") return ru_video_watch_heading(inputs)
	if (locale === "tr") return tr_video_watch_heading(inputs)
	if (locale === "it") return it_video_watch_heading(inputs)
	if (locale === "pl") return pl_video_watch_heading(inputs)
	if (locale === "uk") return uk_video_watch_heading(inputs)
	if (locale === "hi") return hi_video_watch_heading(inputs)
	if (locale === "ar") return ar_video_watch_heading(inputs)
	if (locale === "ms") return ms_video_watch_heading(inputs)
	if (locale === "bn") return bn_video_watch_heading(inputs)
	if (locale === "zh-TW") return zh_tw2_video_watch_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_video_watch_heading(inputs)
	if (locale === "ur") return ur_video_watch_heading(inputs)
	if (locale === "fa") return fa_video_watch_heading(inputs)
	if (locale === "sw") return sw_video_watch_heading(inputs)
	if (locale === "nl") return nl_video_watch_heading(inputs)
	return en_video_watch_heading(inputs)
});